import { Injectable } from '@angular/core';

import { AbstractToolService } from './abstract-tool.service';

import { ControlSpecification } from '../types/specification.types';
import { translateControlSpecitification2LayoutModel } from '../utils/control-translate';
import { LayoutControlContainer } from '../types';

@Injectable({
  providedIn: 'root'
})
export class DrawToolService extends AbstractToolService {
  specification: ControlSpecification;

  constructor() {
    super();
  }

  start(specification: ControlSpecification) {
    this.specification = specification;
  }

  do(host: LayoutControlContainer, args: any) {
    if (host.control.isContainer) {
      const layoutModel = translateControlSpecitification2LayoutModel(this.specification);
      if (host.control.addControl) {
        host.control.addControl(layoutModel);
      }
      // this.RaiseCompletedEvent(args);
    }
  }
}
